import CardCommon from '@op/components/CardCommon';
import React, { useMemo, useState } from 'react';
import { Segment } from 'tea-component';
import { useLocalLanguage } from '@/pages/opinion/utils/languageValue';
import SvgIcon from '@home/components/SvgIcon';
import HotIcon from '@op/assets/svg/hot-segment/hot.svg';
import NewIcon from '@op/assets/svg/hot-segment/new.svg';
import RisingIcon from '@op/assets/svg/hot-segment/rising.svg';
import './index.scss';
import { useKeyOpinionsHotEventList } from '../../hook';
import Sentiment from '@op/components/Snippets/Sentiment';
import { getEventTitleText } from '@op/pages/Summary/utils';
import moment from 'moment';
import { formatTimeToShow } from '@op/utils/time';
import { useHistory } from 'umi';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { goToHotEvent } from '@op/utils/url';
import TextBubbles from '@home/components/TextBubbles';

export default function Events({ filter, gameInfo, languageType }: any) {
  const { language, formatMessage } = useLocalLanguage({
    languageType: languageType || 'origin',
  });
  const [eventType, setEventType] = useState('all');
  const history = useHistory();

  function getShowIconInfo(data: any) {
    return [
      { key: 'rise_icon', icon: RisingIcon },
      { key: 'hot_icon', icon: HotIcon },
      { key: 'new_icon', icon: NewIcon },
    ].map(({ key, icon }) => (
      <React.Fragment key={key}>
        {data[key] === 1 && (
          <img src={icon} className="dbo-opinions-hotevent-img"></img>
        )}
      </React.Fragment>
    ));
  }

  const filterParams = useMemo(() => {
    let days = 1;
    const diffInDays =
      moment(filter.end_time).diff(moment(filter.start_time), 'days') + 1;
    if (diffInDays === 3) {
      days = 3;
    } else if (diffInDays === 7) {
      days = 7;
    }

    const sentimentType = eventType === 'negative' ? 'negative' : 'total';

    return {
      ...(filter || {}),
      filterType: filter?.keyword_filter_types || [],
      channel_type: 'total',
      sentiment_type: sentimentType,
      language: 'all',
      top_n: 15,
      days,
      find_range_time_last_data: true,
    };
  }, [filter, eventType]);

  const { data, loading } = useKeyOpinionsHotEventList({
    filter: filterParams,
    formatData: (data) => data?.list || [],
  });

  const formatData = useMemo(() => {
    if (eventType === 'all' || eventType === 'negative') return data;

    return data.filter((item) => item[eventType] === 1);
  }, [data, eventType]);

  const eventDate = useMemo(() => {
    let days = 1;
    const diffInDays =
      moment(filter.end_time).diff(moment(filter.start_time), 'days') + 1;
    if (diffInDays === 3) {
      days = 3;
    } else if (diffInDays === 7) {
      days = 7;
    }

    if (days === 1) {
      return moment(filter.end_time).format('YYYY-MM-DD');
    }
    return formatTimeToShow(filter);
  }, [filter]);

  return (
    <CardCommon
      className="dbo-noticeable-opinions-events"
      title={
        <div className="dbo-card-title-info">
          <div className="dbo-card-title-info-title">
            {formatMessage({ id: 'Events' })}
          </div>
          <SvgIcon type="arrow-right" className="card-slot-icon" />
          <div className="dbo-card-title-info-desc">({eventDate})</div>
        </div>
      }
      contentCard
      // hasTitleArrow
      handleTitleOnClick={() => {
        let urlData = {};
        if (eventType === 'negative') {
          // urlData = {
          //   sentimentValue: 'negative',
          // };
        } else {
          urlData = {
            filterValue: eventType,
          };
        }
        goToHotEvent({
          gameInfo,
          data: filterParams,
          history,
          urlData: {
            ...urlData,
            ignoreFirst: true,
          },
        });
      }}
      logBtnId="KONO_Event"
    >
      <Segment
        options={[
          { text: formatMessage({ id: 'All' }), value: 'all' },
          {
            text: (
              <div className="dbo-inlineflex">
                <img src={HotIcon} />
                {formatMessage({ id: 'Hot' })}
              </div>
            ),
            value: 'hot_icon',
          },
          {
            text: (
              <div className="dbo-inlineflex">
                <img src={RisingIcon} />
                {formatMessage({ id: 'Rising' })}
              </div>
            ),
            value: 'rise_icon',
          },
          {
            text: (
              <div className="dbo-inlineflex">
                <img src={NewIcon} />
                {formatMessage({ id: 'New' })}
              </div>
            ),
            value: 'new_icon',
          },
          {
            text: (
              <div className="dbo-inlineflex">
                <SvgIcon type="laugh-red-color" />
                {formatMessage({ id: 'Negative' })}
              </div>
            ),
            value: 'negative',
          },
        ]}
        value={eventType}
        onChange={(value) => {
          buriedBtnPoint('KONO_EventsType');
          setEventType(value);
        }}
      />
      <div className="dbo-opinions-hotevent-list">
        {/* 列表标题 */}
        <div className="dbo-opinions-hotevent-list-header">
          <span>{formatMessage({ id: 'Topics' })}</span>
          <span>{formatMessage({ id: 'Mentions' })}</span>
        </div>
        <CardCommon
          contentCard
          className={'dbo-opinions-hotevent-list-content'}
          loading={loading}
          loadingHeight={236}
          empty={formatData?.length === 0}
          hasEmptyImg={false}
          hasEmptyTitle={false}
          hasEmptyDesc={false}
          emptyDescElement={
            <div style={{ textAlign: 'center' }}>
              {formatMessage({
                id: 'No Data under the current filter settings.',
              })}
              <br />
              {formatMessage({
                id: 'Only single-day data summaries are supported.',
              })}
            </div>
          }
          // emptyDescText={formatMessage({
          //   id: 'No Data under the current filter settings. Only single-day data summaries are supported.',
          // })}
        >
          {formatData.map((item: any) => (
            <div className="dbo-opinions-hotevent-item" key={item.id}>
              <div className="dbo-opinions-hotevent-item-title">
                <Sentiment
                  className="dbo-opinions-hotevent-icon"
                  sentiment={item.avg_sentiment}
                  showValue={false}
                ></Sentiment>
                <TextBubbles
                  text={getEventTitleText(item, language)}
                  className="dbo-opinions-hotevent-item-title-text"
                >
                  {getEventTitleText(item, language)}
                </TextBubbles>
                {getShowIconInfo(item)}
              </div>
              <div className="dbo-opinions-hotevent-item-num">
                <span>{item.mentions}</span>
              </div>
            </div>
          ))}
        </CardCommon>
      </div>
    </CardCommon>
  );
}
